import { Stack } from '@mui/material'
import { useOnboardingLayoutContext } from '../../hooks/useOnboardingLayoutContext/useOnboardingLayoutContext'
import { OnboardingStepper } from './components/OnboardingStepper/OnboardingStepper'
import {
  OnboardingProgressBar,
  type OnboardingProgressBarProps,
} from './components/OnboardingProgressBar/OnboardingProgressBar'
import { OnboardingBanners } from './components/OnboardingBanners/OnboardingBanners'

interface OnboardingTopSectionProps extends Pick<OnboardingProgressBarProps, 'businessType'> {
  hasProgressBar?: boolean
  visibility: 'mobile' | 'desktop'
}

export const OnboardingTopSection: Settle.FC<OnboardingTopSectionProps> = ({
  businessType,
  hasProgressBar,
  visibility,
  ...props
}) => {
  const { flowType } = useOnboardingLayoutContext()

  return (
    <Stack
      sx={{
        ...(visibility === 'mobile'
          ? { display: { xs: 'flex', mobile: 'none' }, width: '100%' }
          : { display: { xs: 'none', mobile: 'flex' }, mx: 'auto' }),
      }}
      {...props}
    >
      {hasProgressBar && <OnboardingProgressBar businessType={businessType} />}
      {flowType && <OnboardingStepper />}
      <OnboardingBanners />
    </Stack>
  )
}
